import router from './router'
import { getCookies } from '@/utils/cookies'
import { constantRouterMap } from '@/router'
import store from './store'
store.dispatch('SetMenuList', constantRouterMap)
router.beforeEach((to, from, next) => {
  console.log('to...', to)
  store.dispatch('SetLoader', {status: true, message: 'Loading Page..'})
  document.title = to.meta.title
  if (to.path === '/login' || to.path === '/error/404') {
    console.log('to1', to)
    next()
  } else {
    var authToken = getCookies('authToken')
    console.log('authToken...', authToken)
    if (authToken === undefined) {
      if (to.name !== 'login') {
        localStorage._ruData55 = JSON.stringify(to)
      }
      next('/login')
    } else {
      console.log('to2')
      console.log(store.getters.isAdmin)
      next()
    }
  }
})
router.afterEach((to, from, next) => {
  store.dispatch('SetLoader', {status: false, message: ''})
})



// WEBPACK FOOTER //
// ./src/permissions.js